import React, { useState, useEffect, useRef } from 'react'
import './header.css'
import { HiX, HiOutlineMenu } from 'react-icons/hi'
import { FaSun, FaMoon } from 'react-icons/fa'
import { data } from './data'

const Header = ({ currentPath, scrollToSection, isDarkMode, setDarkMode }) => {
  const [toggle, showMenu] = useState(false)
  const menuRef = useRef(null)

  // Handle scroll event to add class to header
  useEffect(() => {
    const handleScroll = () => {
      const header = document.querySelector('.header')
      if (window.scrollY >= 80) {
        header.classList.add('scroll-header')
      } else {
        header.classList.remove('scroll-header')
      }
    }

    window.addEventListener('scroll', handleScroll)

    return () => {
      window.removeEventListener('scroll', handleScroll)
    }
  }, [])

  // Handle click outside to close menu
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (menuRef.current && !menuRef.current.contains(event.target)) {
        showMenu(false)
      }
    }

    document.addEventListener('mousedown', handleClickOutside)

    return () => {
      document.removeEventListener('mousedown', handleClickOutside)
    }
  }, [])

  return (
    <header className="header">
      <nav className="nav container">
        <a
          href="/"
          className={`nav__logo ${currentPath === '/' ? 'active' : ''}`}
          onClick={(e) => {
            e.preventDefault()
            window.scrollTo({ top: 0, behavior: 'smooth' })
            scrollToSection('/', 'home', e)
          }}
        >
          Abhishek Honnapure
        </a>
        <div
          ref={menuRef}
          className={toggle ? 'nav__menu show-menu' : 'nav__menu'}
        >
          <ul className="nav__list grid">
            {data.map((item) => (
              <li className="nav__item" key={item.id}>
                <a
                  href={item.path}
                  className={`nav__link ${currentPath === item.path ? 'active-link' : ''} transition duration-300 ease-in-out`}
                  onClick={(e) => scrollToSection(item.path, item.id, e)}
                >
                  <item.icon className="nav__icon" /> {item.label}
                </a>
              </li>
            ))}
            <button
              id="theme-toggle"
              className="theme-toggle-button nav__link"
              onClick={() => setDarkMode((prev) => !prev)}
            >
              {isDarkMode ? (
                <>
                  <FaMoon className="icon moon-icon" />
                </>
              ) : (
                <>
                  <FaSun className="icon sun-icon" />
                </>
              )}
            </button>
          </ul>
          <HiX className="nav__close" onClick={() => showMenu(!toggle)} />
        </div>
        <div className="nav_buttons">
          <div className="nav_darkbutton">
            <button
              id="theme-toggle"
              className="dark-toggle-button"
              onClick={() => setDarkMode((prev) => !prev)}
            >
              {isDarkMode ? (
                <>
                  <FaMoon className="icon moon-icon" />
                </>
              ) : (
                <>
                  <FaSun className="icon sun-icon" />
                </>
              )}
            </button>
          </div>
          <div className="nav__toggle" onClick={() => showMenu(!toggle)}>
            <HiOutlineMenu />
          </div>
        </div>
      </nav>
    </header>
  )
}

export default Header
